import React, { Fragment, useContext, useState } from 'react'

import classNames from 'classnames'
import { usePopper } from 'react-popper'

import { faEllipsisV } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Menu, Transition } from '@headlessui/react'
import Button from 'Root/App/Button'

import Context from '../Context'
import styles from './index.module.css'
import { popper } from './utilities'

interface Props {
  buttonSize?: 'XS' | 'S' | 'M' | 'L'
  className?: string
}

const Container = ({ buttonSize = 'XS', className = 'bg-gray-100' }: Props) => {
  const items = useContext(Context)
  const [referenceElement, setReferenceElement] = useState(null)
  const [popperElement, setPopperElement] = useState(null)

  const card = Boolean(referenceElement)
    ? referenceElement.closest('[data-card-id]')
    : null

  const { styles: popperStyles, attributes } = popper(
    usePopper,
    referenceElement,
    popperElement,
    card
  )

  return (
    <Menu as="div" className="relative">
      <span ref={setReferenceElement}>
        <Menu.Button
          as={Button}
          className={classNames(styles.button, className)}
          icon={<FontAwesomeIcon icon={faEllipsisV} />}
          size={buttonSize}
          subtype="circle"
        />
      </span>

      <div
        className="z-10"
        ref={setPopperElement}
        style={popperStyles.popper}
        {...attributes.popper}
      >
        <Transition
          as={Fragment}
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <Menu.Items className={styles.items}>{items}</Menu.Items>
        </Transition>
      </div>
    </Menu>
  )
}

export default Container
